import Vue from 'vue';
import App from './App.vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';

import './main.css';
import router from './router';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueRouter);

import store from './stores';

router.beforeEach((to, from, next) => {
  const pendingInterval = window.setInterval(() => {
    const { isPending, isAuthenticated } = store.state.auth;
    if (!isPending) {
      window.clearInterval(pendingInterval);

      const { requireAuth, login } = to.meta;
      if (isAuthenticated) {
        (requireAuth || !login) ? next() : next('/');
      } else {
        !requireAuth ? next() : next('/');
      }
    }
  }, 100);
});

new Vue({
  router,
  data: { a: 1 },
  render: h => h(App),
}).$mount('#app');
